module.exports = __webpack_public_path__ + "img/empty-notification-bell.16aa578b.png";